export enum AccountsStoreState {
    None,
    Loading,
    AccountsLoadSuccessful,
    AccountsLoadError
}
